export const numberToMoney = (number) => {
	return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};
